import React from "react";
import ReactDOM from "react-dom";
import App from "@data-force/app";
import {Route} from "react-router";
import {Modal} from "antd";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {actionWatcher as addTranslationSagaActionWatcher} from "./store/sagas/antdTranslation";
import antdTranslationReducer from "./store/reducers/antdTranslation";
import "./index.scss";
import MainView from "./pages/MainView/MainView";
import MarkupPreview from "./components/MarkupPreview/MarkdownPreview";
import {mainSagaActionWatcher} from "./store/sagas/main";
import jobReducer from "./store/reducers/job";
import {jobSagaActionWatcher} from "./store/sagas/job";
import homeReducer from "./store/reducers/home";
import {homeSagaActionWatcher} from "./store/sagas/home";
import taskReducer from "./store/reducers/task";
import {taskSagaActionWatcher} from "./store/sagas/task";
import faqReducer from "./store/reducers/faq";
import {faqSagaActionWatcher} from "./store/sagas/faq";
import maskReducer from "./store/reducers/mask";
import mobileReducer from "./store/reducers/mobile";
import focusElementReducer from "./store/reducers/focusElement";
import "./assets/fonts";
import "./assets/dayjs-locales";

ReactDOM.render(
    <App
        sagasToFork={[
            mainSagaActionWatcher,
            addTranslationSagaActionWatcher,
            homeSagaActionWatcher,
            jobSagaActionWatcher,
            taskSagaActionWatcher,
            faqSagaActionWatcher,
        ]}
        reducers={{
            antdTranslation: antdTranslationReducer,
            job: jobReducer,
            task: taskReducer,
            home: homeReducer,
            faq: faqReducer,
            mask: maskReducer,
            mobile: mobileReducer,
            focusElement: focusElementReducer,
        }}
        axiosErrors={{
            500: {
                dialog: Modal.error,
                customOkText: true,
            },
            502: {
                dialog: Modal.error,
            },
            503: {
                dialog: Modal.error,
            },
            409: {
                dialog: Modal.confirm,
                customOkText: true,
                dialogConfig: {
                    className: "df-claim-limit",
                    icon: <ExclamationCircleOutlined aria-hidden/>,
                    centered: true,
                    okCancel: false,
                },
            },
            412: {
                dialog: Modal.error,
            },
            415: {
                dialog: Modal.error,
            },
            429: {
                dialog: Modal.confirm,
                customOkText: true,
                customCancelText: true,
                dialogConfig: {
                    icon: "close-circle",
                    cancelButtonProps: {
                        type: "primary",
                    },
                },
            },
        }}
    >
        <Route path="/tpa/markupTemplateChecker" exact component={MarkupPreview}/>
        <Route path="/" component={MainView}/>
    </App>,
    document.getElementById("root"),
);
